import { useEffect } from "react";

import { getPreferenceChannel } from "~/v3-poc/kernel/channels/preferences";

/**
 * Applies one preference key broadcast by another window. `parse` and `apply`
 * must be stable — a module-level parser and a `useState` setter both are.
 * Applying goes straight to state, never through the setter, so a received
 * change cannot echo back onto the channel.
 */
export const usePreferenceSync = <Value>(
  key: string,
  parse: (stored: string) => Value | undefined,
  apply: (value: Value) => void,
): void => {
  useEffect(() => {
    const unsubscribe = getPreferenceChannel().subscribe((message) => {
      if (message.key !== key) {
        return;
      }
      const value = parse(message.value);
      if (value !== undefined) {
        apply(value);
      }
    });
    return unsubscribe;
  }, [key, parse, apply]);
};
